import { TranslationsContext } from '@teliaee/telia-translate';
import { Button, Collapse, CollapseProvider, CollapseTrigger, List, ListItem } from 'telia-front-react';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import sha1 from 'sha1';
import RoamingStore from '../../../stores/RoamingStore';
import GaHelper from '../../../util/GaHelper';

interface ServiceGroupCommentsProps {
  serviceGroupId: number;
  roamingStore?: RoamingStore;
}

@observer
class ServiceGroupComments extends React.Component<ServiceGroupCommentsProps> {
  static contextType = TranslationsContext;
  declare context: React.ContextType<typeof TranslationsContext>;

  public render() {
    const translate = this.context.translate;
    const { serviceGroupId } = this.props;
    const commentListItems = this.getCommentsListForServiceGroup(serviceGroupId);
    if (!commentListItems) {
      return null;
    }
    return (
      <CollapseProvider
        id={`${serviceGroupId}-collapse`}
        onToggle={(open) =>
          GaHelper.pushGaData({
            eventAction: 'Hinnad välismaal',
            eventLabel: `Link - Loen lähemalt - ${serviceGroupId === 2 ? 'kõned-ja-sõnumid' : 'internet'} - ${open ? 'open' : 'close'}`
          })
        }
      >
        <CollapseTrigger>
          <Button text={translate('roaming.operator.read-more')} url={`${serviceGroupId}-collapse`} link={true} iconRight="#arrow-down" />
        </CollapseTrigger>
        <Collapse>
          <List>{commentListItems}</List>
        </Collapse>
      </CollapseProvider>
    );
  }

  private getCommentsListForServiceGroup(id: number) {
    const serviceGroup = this.props.roamingStore.selectedOperatorServiceGroupById(id);
    return serviceGroup
      ? serviceGroup.groupNotes.map((note, i) => {
          return <ListItem key={`comment-${i}-${sha1(note.notePrompt)}`}>{note.notePrompt}</ListItem>;
        })
      : '';
  }
}

export default inject('roamingStore')(ServiceGroupComments);
